import { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import { css, CSSProperties } from "@linaria/core";
import { COLOR_BLACK, COLOR_BLUE_DARK, COLOR_BLUE_LIGHT, COLOR_BLUE_LIGHTER, COLOR_GRAY_DARK, COLOR_GRAY_LIGHT, COLOR_GRAY_LIGHTER, COLOR_SHADOW, COLOR_WHITE } from "../../constants";
export const buttonClassName = "b1uioams";
type ButtonStyle = {
  "--button-active-backgroundColor": string;
  "--button-active-borderColor": string;
  "--button-active-color": string;
  "--button-default-backgroundColor": string;
  "--button-default-borderColor": string;
  "--button-default-color": string;
  "--button-disabled-backgroundColor": string;
  "--button-disabled-borderColor": string;
  "--button-disabled-color": string;
  "--button-focus-backgroundColor": string;
  "--button-focus-borderColor": string;
  "--button-focus-color": string;
  "--button-hover-backgroundColor": string;
  "--button-hover-borderColor": string;
  "--button-hover-color": string;
};
const defaultTheme: ButtonStyle = {
  "--button-active-backgroundColor": COLOR_GRAY_DARK,
  "--button-active-borderColor": COLOR_GRAY_DARK,
  "--button-active-color": COLOR_WHITE,
  "--button-default-backgroundColor": COLOR_GRAY_LIGHTER,
  "--button-default-borderColor": COLOR_GRAY_LIGHTER,
  "--button-default-color": COLOR_BLACK,
  "--button-disabled-backgroundColor": COLOR_GRAY_LIGHTER,
  "--button-disabled-borderColor": COLOR_GRAY_LIGHTER,
  "--button-disabled-color": COLOR_SHADOW,
  "--button-focus-backgroundColor": COLOR_BLACK,
  "--button-focus-borderColor": COLOR_GRAY_LIGHTER,
  "--button-focus-color": COLOR_BLACK,
  "--button-hover-backgroundColor": COLOR_GRAY_LIGHT,
  "--button-hover-borderColor": COLOR_GRAY_LIGHT,
  "--button-hover-color": COLOR_BLACK
};
const primary: ButtonStyle = {
  "--button-active-backgroundColor": COLOR_BLUE_DARK,
  "--button-active-borderColor": COLOR_BLUE_DARK,
  "--button-active-color": COLOR_WHITE,
  "--button-default-backgroundColor": COLOR_BLUE_LIGHTER,
  "--button-default-borderColor": COLOR_BLUE_LIGHTER,
  "--button-default-color": COLOR_WHITE,
  "--button-disabled-backgroundColor": COLOR_BLUE_LIGHTER,
  "--button-disabled-borderColor": COLOR_BLUE_LIGHTER,
  "--button-disabled-color": COLOR_SHADOW,
  "--button-focus-backgroundColor": COLOR_BLACK,
  "--button-focus-borderColor": COLOR_BLUE_LIGHTER,
  "--button-focus-color": COLOR_WHITE,
  "--button-hover-backgroundColor": COLOR_BLUE_LIGHT,
  "--button-hover-borderColor": COLOR_BLUE_LIGHT,
  "--button-hover-color": COLOR_WHITE
};
export const buttonStyles = {
  default: defaultTheme,
  primary
};
export const buttonSizes = {
  default: {
    "--button-fontSize": "1.2rem",
    "--button-minWidth": "9.3rem"
  },
  large: {
    "--button-fontSize": "1.8rem",
    "--button-minWidth": "11.3rem"
  }
};

function Button({
  buttonStyle = "default",
  buttonSize = "default",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  buttonStyle?: keyof typeof buttonStyles;
  buttonSize?: keyof typeof buttonSizes;
}): JSX.Element {
  const style: CSSProperties = props.style ? { ...buttonStyles[buttonStyle],
    ...buttonSizes[buttonSize],
    ...props.style
  } : { ...buttonStyles[buttonStyle],
    ...buttonSizes[buttonSize]
  };
  return <button {...props} className={`${buttonClassName} ${props.className || ""}`} style={style} />;
}

export function ButtonLink({
  buttonStyle = "default",
  buttonSize = "default",
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  buttonStyle?: keyof typeof buttonStyles;
  buttonSize?: keyof typeof buttonSizes;
}): JSX.Element {
  const style: CSSProperties = props.style ? { ...buttonStyles[buttonStyle],
    ...buttonSizes[buttonSize],
    ...props.style
  } : { ...buttonStyles[buttonStyle],
    ...buttonSizes[buttonSize]
  };
  return <a {...props} className={`${buttonClassName} ${props.className || ""}`} style={style} />;
}
export default Button;

require("../../../.linaria-cache/src/components/button/index.linaria.module.css");